export function getCurrentUrl(): string {
    // window.location 객체를 통해 현재 URL 정보에 접근
    const { protocol, hostname, port } = window.location;

    // 포트가 80이 아닌 경우에만 포트를 포함한 URL 반환
    const portSuffix = (port === '80' ||  port === '443') ? '' : `:${port}`;

    // 조합된 URL 반환
    return `${protocol}//${hostname}${portSuffix}/`;
}

export function getCurrentTimestamp(): string {
    const now = new Date();

    const pad = (n: number, width: number) => {
        return n.toString().padStart(width, '0');
    };

    const yyyy = now.getFullYear();
    const MM = pad(now.getMonth() + 1, 2);
    const dd = pad(now.getDate(), 2);
    const HH = pad(now.getHours(), 2);
    const mm = pad(now.getMinutes(), 2);
    const ss = pad(now.getSeconds(), 2);
    const SSS = pad(now.getMilliseconds(), 3);

    return `${yyyy}${MM}${dd}${HH}${mm}${ss}${SSS}`;
}